import { ENUM_AdvisorUserPermissionLevel } from '@api-new/common';
import { HTTP_AP_ListAdvisorUsers_ForTable_Request_Sort } from '@api-new/userservice';
import { UserTableRowModel } from '@platform/user/models/user-table.model';
import { UserTableFilterModel } from '@platform/user/pages/user-table/models/user-table-filter.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const userTableFilterDefaults: UserTableFilterModel = {
  displayNameOrEmail: null,
  companyIds: null,
  networkIds: [],
  advisorUserPermissionSettings: null,
  neverSignIn: null,
};

export const userTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
): TableRowDefinitionModel<UserTableRowModel, HTTP_AP_ListAdvisorUsers_ForTable_Request_Sort>[] => {
  return [
    {
      columnLabel: 'Name',
      sortKey: 'byDisplayName',
      type: RowDefinitionTypeEnum.Text,
      columnKey: 'displayName',
      width: {
        min: '240px',
        max: '240px',
      },
      isFrozen: true,
    },
    {
      columnLabel: 'Last login',
      sortKey: 'byLastSignIn',
      type: RowDefinitionTypeEnum.DateTimeSince,
      columnKey: 'lastSignIn',
      width: {
        min: '120px',
        max: '120px',
      },
    },
    {
      columnLabel: 'Company',
      sortKey: 'byCompany',
      type: RowDefinitionTypeEnum.Text,
      columnKey: 'companyName',
      width: {
        min: '200px',
        max: '200px',
      },
      isHidden: !hasCurrentUserRequiredPermissions([
        {
          permission: PermissionEnum.AdvisorUserRead,
          permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_COMPANY,
        },
      ]),
    },
    {
      columnLabel: 'Email',
      sortKey: 'byEmail',
      type: RowDefinitionTypeEnum.Text,
      columnKey: 'email',
      width: {
        min: '240px',
        max: '240px',
      },
    },
    {
      columnLabel: 'Clients',
      type: RowDefinitionTypeEnum.Number,
      columnKey: 'clientCount',
      width: {
        min: '70px',
        max: '90px',
      },
    },

    {
      columnLabel: 'Is Admin',
      type: RowDefinitionTypeEnum.Boolean,
      columnKey: 'hasAdminPermission',
      width: {
        min: '100px',
        max: '150px',
      },
      isHidden: !hasCurrentUserRequiredPermissions([
        {
          permission: PermissionEnum.AdvisorUserRead,
          permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_FULL,
        },
      ]),
    },
    {
      columnLabel: 'Special Permissions',
      type: RowDefinitionTypeEnum.Boolean,
      columnKey: 'hasSpecialPermission',
      width: {
        min: '100px',
        max: '150px',
      },
      isHidden: !hasCurrentUserRequiredPermissions([
        {
          permission: PermissionEnum.AdvisorUserRead,
          permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_FULL,
        },
      ]),
    },
    {
      columnLabel: 'Permissions Company',
      type: RowDefinitionTypeEnum.Number,
      columnKey: 'permissionsCompany',
      width: {
        min: '100px',
        max: '150px',
      },
      isHidden: !hasCurrentUserRequiredPermissions([
        {
          permission: PermissionEnum.AdvisorUserRead,
          permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_FULL,
        },
      ]),
    },
    {
      columnLabel: 'Permissions Network',
      type: RowDefinitionTypeEnum.Number,
      columnKey: 'permissionsNetwork',
      width: {
        min: '100px',
        max: '150px',
      },
      isHidden: !hasCurrentUserRequiredPermissions([
        {
          permission: PermissionEnum.AdvisorUserRead,
          permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_FULL,
        },
      ]),
    },
    {
      columnLabel: 'Permissions Full',
      type: RowDefinitionTypeEnum.Number,
      columnKey: 'permissionsFull',
      width: {
        min: '100px',
        max: '150px',
      },
      isHidden: !hasCurrentUserRequiredPermissions([
        {
          permission: PermissionEnum.AdvisorUserRead,
          permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_FULL,
        },
      ]),
    },
  ];
};
